import { render } from "./PageWithLeftMenu.vue?vue&type=template&id=26eaa366&scoped=true&ts=true"
import script from "./PageWithLeftMenu.vue?vue&type=script&lang=ts"
export * from "./PageWithLeftMenu.vue?vue&type=script&lang=ts"

import "./PageWithLeftMenu.vue?vue&type=style&index=0&id=26eaa366&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26eaa366"]])

export default __exports__